/* tslint:disable */
export enum UniquenessType {
  Email = 1,
  TaxNumber = 2,
  SocialSecurityNumber = 3
}
